"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { createPortal } from "react-dom";
import Header from "@/components/Header";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";

const FilterBar = dynamic(() => import("@/app/cin_booking_engine/Filterbar"), {
  ssr: false,
});

export default function PageShellWithBookingClient({
  children,
  headerProps,
  headerSpacerHeight = 70,
}) {
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);

  useEffect(() => {
    if (typeof window !== "undefined") window.scrollTo(0, 0);
  }, []);

  const handlePropertyBookNow = useCallback(async (property) => {
    setShowFilterBar((prev) => !prev);

    const label = property?.cityName;
    const value = property?.cityId;
    const property_Id = property?.staahPropertyId;
    setCityDetails({ label, value, property_Id });
    setStaahPropertyId(property?.staahPropertyId);

    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      const firstInput = filterBarRef.current.querySelector("input, select, button");
      if (firstInput) firstInput.focus();
    }
  }, []);

  return (
    <>
      <Header onClick={handlePropertyBookNow} {...headerProps} />

      <section ref={filterBarRef} className="position-relative">
        <section className="position-fixed start-0 w-100 bg-white shadow">
          {showFilterBar &&
            typeof window !== "undefined" &&
            createPortal(
              <section className="filter-bar-hotels-cin">
                <BookingEngineProvider>
                  <FilterBar
                    selectedProperty={
                      staahPropertyId != null ? parseInt(staahPropertyId) : undefined
                    }
                    cityDetails={cityDetails}
                    openBookingBar={showFilterBar}
                    onClose={(isReload) => {
                      setShowFilterBar(false);
                      if (isReload) window.location.reload();
                    }}
                    isCloseButtonShow="true"
                  />
                </BookingEngineProvider>
              </section>,
              document.body,
            )}
        </section>
      </section>

      {headerSpacerHeight ? <div style={{ paddingTop: `${headerSpacerHeight}px` }} /> : null}
      {children}
    </>
  );
}

